(() => {
  const slugify = str =>
    str
      .toLowerCase()
      .replace(/'s\b/g, 's')          
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  const cache = new Map();

  const fetchProductByHandle = async (handle) => {
    if (cache.has(handle)) return cache.get(handle);

    const promise = (async () => {
      try {
        const r = await fetch(`/products/${handle}.js`);
        if (!r.ok) return null;
        const p = await r.json();
        const variantId = p?.variants?.[0]?.id;
        if (variantId) cache.set(variantId, handle); 
        return variantId;
      } catch {
        return null;
      }
    })();

    cache.set(handle, promise);
    return promise;
  };

  const patchCard = async card => {
    if (card.dataset._patched) return;
    card.dataset._patched = 'true';

    let handle = 
      card.getAttribute('data-product-handle') ||
      card.getAttribute('data-handle') ||
      card.getAttribute('data-handle-slug') ||
      card.getAttribute('data-product');

    if (!handle) {
      const link = card.querySelector('a[href*="/products/"]');
      const match = link?.pathname.match(/\/products\/([^/?#]+)/);
      if (match) handle = match[1];
    }

    if (!handle) {
      const titleEl = card.querySelector('.name,[aria-label]');
      const raw = titleEl?.textContent || titleEl?.getAttribute('aria-label');
      if (raw) handle = slugify(raw);
    }

    let variantId = 
      card.getAttribute('data-variant-id') ||
      card.getAttribute('data-id') ||
      card.querySelector('input[name="id"]')?.value ||
      card.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');

    if (variantId && !handle) {
      const titleEl = card.querySelector('.name,[aria-label]');
      const raw = titleEl?.textContent || titleEl?.getAttribute('aria-label');
      if (raw) handle = slugify(raw);
    }
    
    if (!variantId && handle) variantId = await fetchProductByHandle(handle);

    if (!handle || !variantId) return;

    const elements = [card, ...card.querySelectorAll('.fs-recommendation-price-container')];
    elements.forEach(el => {
      el.dataset.productHandle = handle;
      el.dataset.variantId = variantId;
    });
  };

  const scan = root => 
    root.querySelectorAll('.product-container:not([data-_patched])').forEach(patchCard);

  const start = () => {
    const container = document.querySelector('.upsell-cross-sell-product-grid') || document.body;
    scan(container);
    new MutationObserver(muts =>
      muts.forEach(({ addedNodes }) =>
        addedNodes.forEach(node => node.nodeType === 1 && scan(node))
      )
    ).observe(container, { childList: true, subtree: true });
  };

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();

(() => {
  const SELECTOR = 'a.fast-ac-item.fs-product';
  const CONTAINER_SELECTOR = '.fast-simon-autocomplete, .autocomplete.fast-simon-autocomplete, [id^="fast-autocomplete-"]';
  const handleRegex = /\/products\/([^/?#]+)/;
  const pageHandle = (() => {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  })();

  const getHandleFromHref = href => {
    const m = href && href.match(handleRegex);
    return m ? m[1] : null;
  };

  const deepQuerySelectorAll = (root, selector) => {
    let out = [];
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(el => out.push(el));
    root.querySelectorAll?.('*').forEach(el => { if (el.shadowRoot) out = out.concat(deepQuerySelectorAll(el.shadowRoot, selector)); });
    return out;
  };

  const containerIsOpen = c => c.getAttribute('aria-expanded') === 'true';

  const processProducts = (container) => {
    if (!containerIsOpen(container)) return;
    const items = deepQuerySelectorAll(container, SELECTOR);
    for (const el of items) {
      const href = el.getAttribute('href');
      const handle = getHandleFromHref(href);
      if (!handle) continue;
      if (pageHandle && handle === pageHandle) { el.removeAttribute('data-product-handle'); continue; }
      if (el.getAttribute('data-product-handle') !== handle) el.setAttribute('data-product-handle', handle);
    }
  };

  let renderTimer = null;
  const scheduleAbraRender = () => {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(() => { try { window?.Abra?.render?.(); } catch(_) {} }, 500);
  };

  const observed = new WeakSet();
  const attachObserverTo = (container) => {
    if (observed.has(container)) return;
    observed.add(container);
    processProducts(container);
    let rafId = null;
    const mo = new MutationObserver(() => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => { processProducts(container); scheduleAbraRender(); });
    });
    mo.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  };

  const scanForContainers = () => { deepQuerySelectorAll(document, CONTAINER_SELECTOR).forEach(attachObserverTo); };

  scanForContainers();
  setInterval(scanForContainers, 1000);
})();
